import React, { useMemo, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import BackToTop from "./components/BackToTop/BackToTop";
import Home from "./pages/Home";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import ResumePage from "./pages/ResumePage";
import "./styles/global.css";

const ThemeContext = React.createContext();

function App() {
  const [mode, setMode] = useState(
    localStorage.getItem("portfolio-theme") || "light"
  );

  const toggleTheme = () => {
    const next = mode === "light" ? "dark" : "light";
    setMode(next);
    localStorage.setItem("portfolio-theme", next);
    document.documentElement.setAttribute("data-theme", next);
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: mode === "light" ? "#2563eb" : "#60a5fa",
          },
          secondary: {
            main: mode === "light" ? "#7c3aed" : "#a78bfa",
          },
          background: {
            default: mode === "light" ? "#f8fafc" : "#0f172a",
            paper: mode === "light" ? "#ffffff" : "#111827",
          },
        },
        shape: {
          borderRadius: 16,
        },
        typography: {
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          h1: {
            fontFamily: '"Space Grotesk", "Inter", sans-serif',
            fontWeight: 800,
          },
          h2: {
            fontFamily: '"Space Grotesk", "Inter", sans-serif',
            fontWeight: 800,
          },
          h3: {
            fontFamily: '"Space Grotesk", "Inter", sans-serif',
            fontWeight: 700,
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Header />
          <BoxShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/resume" element={<ResumePage />} />
            </Routes>
          </BoxShell>
          <Footer />
          <BackToTop />
        </Router>
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

const BoxShell = ({ children }) => {
  return <div style={{ minHeight: "calc(100vh - 160px)" }}>{children}</div>;
};

export { ThemeContext };
export default App;
